export default __webpack_public_path__ + "static/media/palmerston.ffb9dac6.jpg";